import { FilterType } from 'components/Shared/Table'
import { CAR_CONTRACTOR_READ, CAR_DATA_READ, CAR_DRIVER_READ, } from 'context/auth'
import driverStatusOptions from 'constants/driverStatusOptions'

export const createColumns = (hasAnyPrivileges) => {
  const carDriverColumns = hasAnyPrivileges([CAR_DRIVER_READ]) ? [{
    id: 'driverStatuses',
    label: 'driver.status.title',
    path: 'driver.status',
    filterType: FilterType.Select,
    selectOptions: driverStatusOptions,
    statusToIndicatorColorMap: {
      TRAFFIC_JAM: '#FFEE18',
      ACCIDENT: '#ED1C24',
      AVAILABLE: '#65D609',
      UNAVAILABLE: '#030B6F'
    }
  }] : []

  const carDataColumns = hasAnyPrivileges([CAR_DATA_READ]) ? [
    {
      id: 'registrationNumber',
      label: 'car.registrationNumber',
      path: 'registrationNumber',
      filterType: FilterType.Text
    },
    {
      id: 'brand',
      label: 'car.brand',
      path: 'brand',
      filterType: FilterType.Text
    },
    {
      id: 'model',
      label: 'car.model',
      path: 'model',
      filterType: FilterType.Text
    },
    {
      id: 'trailerRegistrationNumber',
      label: 'car.trailerRegistrationNumber',
      path: 'trailerRegistrationNumber',
      filterType: FilterType.Text
    },
    {
      id: 'loadingSpace',
      label: 'car.loadingSpace',
      path: 'loadingSpace',
      filterType: FilterType.Text
    },
    {
      id: 'capacity',
      label: 'car.capacity',
      path: 'capacity',
      filterType: FilterType.Text
    },
    {
      id: 'type',
      label: 'car.type',
      path: 'type',
      filterType: FilterType.Text
    },
    {
      id: 'driverName',
      label: 'car.driver.name',
      path: 'driver.name',
      filterType: FilterType.Text
    },
    {
      id: 'phoneNumber',
      label: 'car.driver.phoneNumber',
      path: 'driver.phoneNumber',
      filterType: FilterType.Text
    }
  ] : []

  const carContractorColumns = hasAnyPrivileges([CAR_CONTRACTOR_READ]) ? [{
    id: 'carrierIds',
    label: 'car.carrier',
    path: 'carrierId',
    filterType: FilterType.Contractor
  }] : []

  return [
    ...carDriverColumns,
    ...carDataColumns,
    ...carContractorColumns
  ]
}
